
import React from "react";
import { useHistory } from "react-router-dom";

import EvaGuidedTour from "./ai/components/EvaGuidedTour";

//========================================================
// Eva Workplace
//
// Container page for the interactive workplace experience.
//
// Uses the existing EvaGuidedTour component.
//
// Future additions:
// - Interactive hotspots
// - Document and video popups
// - Workplace surveys
// - Asset information
// - Contextual Ask Eva
//========================================================

export default function EvaWorkplace()
{

    //----------------------------------------------------
    // Navigation
    //----------------------------------------------------

    const history = useHistory();


    //----------------------------------------------------
    // Actions
    //----------------------------------------------------

    const openEvaChat = () =>
    {
        history.push("/evamainchat");
    };


    const returnToEva = () =>
    {
        history.push("/eva");
    };


    //----------------------------------------------------
    // Render
    //----------------------------------------------------

    return (

        <div className="eva-workplace">

            {/*============================================
              Existing Guided Tour
            ============================================*/}

            <EvaGuidedTour />


            {/*============================================
              Workplace Controls
            ============================================*/}

            <div className="eva-workplace-controls">

                <button
                    type="button"
                    className="eva-workplace-back"
                    onClick={returnToEva}
                >
                    ← Back to Eva
                </button>

                <button
                    type="button"
                    className="eva-workplace-ask"
                    onClick={openEvaChat}
                >
                    ✦ Ask Eva
                </button>

            </div>

        </div>

    );

}
